export default __webpack_public_path__ + "static/bg_header_night-d76d1dbdbc3019d663369258058b45cf.svg";